export default "__VITE_ASSET__Dqa$OV_y__"